import { HiMoon, HiSun } from 'react-icons/hi2';
import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative flex h-10 w-10 items-center justify-center rounded-xl text-text-main transition-all duration-500 hover:bg-page-surface border border-transparent hover:border-border-subtle hover:scale-110 active:scale-95 shadow-sm"
      aria-label="Toggle Theme"
    >
      <div className="relative h-5 w-5">
        <HiSun 
          className={`absolute inset-0 h-5 w-5 transition-all duration-300 transform ${
            isDark ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
          } text-orange-500`} 
        />
        <HiMoon 
          className={`absolute inset-0 h-5 w-5 transition-all duration-300 transform ${
            isDark ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'
          } text-primary-accent`} 
        />
      </div>
    </button>
  );
}
